import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";

import { db } from "../firebase/config";

export function subscribeToEntries(groupId, callback) {
  const entriesRef = collection(db, "groups", groupId, "entries");

  return onSnapshot(
    entriesRef,
    (snapshot) => {
      const data = snapshot.docs.map((document) => ({
        id: document.id,
        ...document.data(),
      }));

      callback(data);
    },
    (error) => {
      console.error("Error loading entries:", error);
      callback([]);
    },
  );
}

export async function addEntry(groupId, entry) {
  await addDoc(collection(db, "groups", groupId, "entries"), {
    ...entry,
    createdAt: serverTimestamp(),
  });
}

export async function updateEntry(groupId, entryId, entry) {
  const entryRef = doc(db, "groups", groupId, "entries", entryId);
  await updateDoc(entryRef, {
    type: entry.type,
    title: entry.title,
    rating: entry.rating,
    status: entry.status,
    tags: entry.tags,
    note: entry.note,
    studio: entry.studio,
    episodes: entry.episodes,
    director: entry.director,
    runtime: entry.runtime,
    artist: entry.artist,
    album: entry.album,
    author: entry.author,
    pages: entry.pages,
  });
}

export async function deleteEntry(groupId, entryId) {
  await deleteDoc(doc(db, "groups", groupId, "entries", entryId));
}
